import type { ChangedPrices } from "_redux/reducers";

const isReponseWithPriceChanges = (
  candidate: unknown
): candidate is { data: { priceChanges: ChangedPrices } } =>
  candidate != null &&
  typeof candidate === "object" &&
  "data" in candidate &&
  candidate.data != null &&
  typeof candidate.data === "object" &&
  "priceChanges" in candidate.data;

export const extractPriceChangesFromResponse = (response: unknown) => {
  if (isReponseWithPriceChanges(response)) {
    return response.data.priceChanges;
  }

  return undefined;
};
